import React from 'react'
import Image from '../../../images/sellerpolicies/10.png'

const Seller_obligations_to_customer_service = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>SELLER OBLIGATIONS TO CUSTOMER SERVICE</h2>
            <p>KAAY may forward questions or complaints received by KAAY’s Customer support department regarding any sold product(s) to the Seller or in-process delivery item. The Seller shall be obliged to respond to KAAY on all such questions or complaints within 24-36 hours of the receipt of such questions or complaints.</p>
            <p>On receiving the Seller’s response to any question or complaint, KAAY shall promptly forward the response to the Customer.</p>
            <p>If a Seller fails to respond to any question or complaint within seventy-two (72) hours of receiving the same, the Seller or any of its Products may be de-listed from the Platform without further notice.</p>
        </div>
      </div>
    </div>
  )
}

export default Seller_obligations_to_customer_service
